import { DEVICE_TYPES } from "../domain/models";

export const selectBmsDevice = (devices) =>
  devices.find((d) => d.type === DEVICE_TYPES.BMS) || null;

export const selectDashboardPdmDevices = (devices) =>
  devices.filter((d) => d.showOnDashboard && d.type === DEVICE_TYPES.PDM_CHANNEL);

export const selectPdmDevices = (devices) =>
  devices.filter((d) => d.type === DEVICE_TYPES.PDM_CHANNEL && d.showOnDevices !== false);

export const selectLevelSensors = (devices) =>
  devices.filter((d) => d.type === DEVICE_TYPES.SENSOR_LEVEL);

export const selectTemperatureSensors = (devices) =>
  devices.filter((d) => d.type === DEVICE_TYPES.SENSOR_TEMPERATURE);

export const selectVeDirectDevices = (devices) =>
  devices.filter((d) => d.type === DEVICE_TYPES.VE_DIRECT);
